// import { authFetch } from '../AuthFetch';
// import { createAction } from 'redux-actions';

export const cleanGlobalMessage = () => (
  (dispatch) => {
   dispatch({
        type: 'CLEAN_GLOBAL_MESSAGE',
        payload: null
      });
  }
);

export const forwardToShowGlobalAlert = (error) => (
  (dispatch) => {
   dispatch({
        type: 'SHOW_GLOBAL_ALERT',
        payload: error
      });
  }
);

export const cleanAction = (dispatch) => {
    dispatch(cleanGlobalMessage());
}


// WEBPACK FOOTER //
// ./src/actions/alertAction.js